
import "./pricingHrms.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ContactSalesModal from "../../component/ContactSalesModal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const PricingHrms = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [showContactModal, setShowContactModal] = useState(false);
    useEffect(() => {
        if (showContactModal && location.hash) {
            navigate(location.pathname, { replace: true });
        }
    }, [showContactModal, location, navigate]);
    const [showPricing, setShowPricing] = useState(false);

    const [billingCycle, setBillingCycle] = useState("monthly");
    const [expandedCards, setExpandedCards] = useState({});
    const toggleFeatures = (index) => {
        setExpandedCards((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };
    const plans = [
        {
            name: "Free",
            color: "success",
            monthly: "Free",
            Annually: "Free",
            discount: 0,
            features: {
                "Payroll processing & benefits": true,
                "Employee attendance": true,
                "Training & compliance Management": true,
                "Attendance & Time": true,
                "Tracking payroll": true,
                "Compensation Management & Competence Mapping": true,
                "Training identification & Training": true,
                "Advance Payment Module": true,
                "Yearly reports & Dashboards": true,
                "HR Analytics & Reporting": true,
                Security: false,
                "Backup and Disaster Recovery (BDR)": false,
                Users: "1 User",
            },
        },
        {
            name: "Silver",
            color: "secondary",
            monthly: "₹180 ",
            Annually: "₹150 ",
            discount: 20,
            popular: true,

            features: {
                "Payroll processing & benefits": true,
                "Employee attendance": true,
                "Training & compliance Management": true,
                "Attendance & Time": true,
                "Tracking payroll": true,
                "Compensation Management & Competence Mapping": true,
                "Training identification & Training": true,
                "Advance Payment Module": true,
                "Yearly reports & Dashboards": true,
                "HR Analytics & Reporting": true,
                Security: true,
                "Backup and Disaster Recovery (BDR)": true,
                Support: "30 Days Online Training",
                Storage: "5 GB",
                Users: "25 Users (Minimum)",
            },
        },
        {
            name: "Gold",
            color: "warning",
            monthly: "₹275 ",
            Annually: "₹250",
            discount: 10,
            features: {
                "Payroll processing & benefits": true,
                "Employee attendance": true,
                "Training & compliance Management": true,
                "Attendance & Time": true,
                "Tracking payroll": true,
                "Compensation Management & Competence Mapping": true,
                "Training identification & Training": true,
                "Advance Payment Module": true,
                "Yearly reports & Dashboards": true,
                "HR Analytics & Reporting": true,
                Security: true,
                "Backup and Disaster Recovery (BDR)": true,
                Support: "30 Days Online Training + Unlimited Support",
                Storage: "15 GB",
                Users: "25 Users (Minimum)",
            },
        },
    ];

    // List all features in order for table rows
    const featureRows = [
        { key: "Payroll processing & benefits", label: "Payroll processing & benefits" },
        { key: "Employee attendance", label: "Employee attendance" },
        { key: "Training & compliance Management", label: "Training & compliance Management" },
        { key: "Attendance & Time", label: "Attendance & Time" },
        { key: "Tracking payroll", label: "Tracking payroll" },
        { key: "Compensation Management & Competence Mapping", label: "Compensation Management & Competence Mapping" },
        { key: "Training identification & Training", label: "Training identification & Training" },
        { key: "Advance Payment Module", label: "Advance Payment Module" },
        { key: "Yearly reports & Dashboards", label: "Yearly reports & Dashboards" },
        { key: "HR Analytics & Reporting", label: "HR Analytics & Reporting" },
        { key: "Security", label: "Security" },
        { key: "Backup and Disaster Recovery (BDR)", label: "Backup and Disaster Recovery (BDR)" },
        { key: "Support", label: "Support" },
        { key: "Storage", label: "Storage" },
        { key: "Users", label: "Users" },
    ];

    return (
        <>

            <Helmet>
                <title>HRMS Software Pricing | Flexible & Affordable HR Software Plans</title>
                <meta
                    name="description"
                    content="Explore flexible HRMS software pricing tailored to your business needs. Compare plans for payroll, attendance, and employee management with transparent costs."
                />
                <meta
                    name="keywords"
                    content="HRMS pricing, HR software pricing, HRMS cost, payroll software pricing, attendance software pricing, HR management system price, HRMS plans, HR software India"
                />
            </Helmet>



            {/* start price  */}
            <section class="app-section  about-areas" id="pricing">
                <div class="shape">
                    {/* <img src={leftSideImg} alt="Shape" /> */}
                </div>
                <div class="container">
                    <div class="site-heading text-center mb-4">
                        <div className="text-center feature-heading" style={{ color: '#0F4F93' }}>Pricing</div>

                        <p>Pay only for what you need. No hidden costs.</p>
                    </div>

                    <div class="row g-4 justify-content-center">
                        <div class="col-lg-3 col-md-6">
                            <div class="softing-card">
                                <div class="card-header dark text-start ">
                                    <span class="fw-bold">Free</span>
                                    <div class="d-flex">  <h3 class="me-2">₹ 0 </h3><span>/Month/User</span></div>
                                    <p class="plan-desc p-0">Explore all of TechCognics ERP's features with no upfront cost
                                    </p>
                                </div>
                                <div className="card-body-btn row mx-1 ">
                                    <button className="border plan-btn-shadow py-2 " onClick={() => setShowContactModal(true)} > <i className="bi bi-rocket-takeoff-fill me-2"></i>Get Started</button>
                                </div>
                                <div class="card-body">
                                    <ul>
                                        <li className="flex items-center gap-2">
                                            <CheckCircleOutlineIcon sx={{ color: "#16a34a", fontSize: 18 }} />
                                            <span>15 Days Trial</span>
                                        </li>
                                        <li className="flex items-center gap-2">
                                            <CheckCircleOutlineIcon sx={{ color: "#16a34a", fontSize: 18 }} />
                                            <span>Documentation</span>
                                        </li>
                                        <li className="flex items-center gap-2">
                                            <CheckCircleOutlineIcon sx={{ color: "#16a34a", fontSize: 18 }} />
                                            <span>Support</span>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6">
                            <div class="softing-card active">
                                <div class="card-header active blue text-start ">
                                    <span class="fw-bold">Silver</span>
                                    <div class="d-flex">  <h3 class="me-2">₹ 150</h3><span>/Month/User</span></div>
                                    <p class="plan-desc p-0">Best choice for small teams initiating digital operations — automated features and continuous updates.
                                    </p>
                                </div>
                                <div className="card-body-btn row mx-1 ">
                                    <button className="border plan-btn-shadow py-2 plan-bg-color " onClick={() => setShowContactModal(true)}> <i className="bi bi-lightning-charge-fill me-2"></i>Start Premium</button>
                                </div>
                                <div class="card-body">
                                    <ul>

                                        <li className="flex items-center gap-2">
                                            <CheckCircleOutlineIcon sx={{ color: "#16a34a", fontSize: 18 }} />
                                            <span>Per month</span>
                                        </li>
                                        <li className="flex items-center gap-2">
                                            <CheckCircleOutlineIcon sx={{ color: "#16a34a", fontSize: 18 }} />
                                            <span>+18% GST</span>
                                        </li>
                                        <li className="flex items-center gap-2">
                                            <CheckCircleOutlineIcon sx={{ color: "#16a34a", fontSize: 18 }} />
                                            <span>Billed Monthly</span>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6">
                            <div class="softing-card">
                                {/* mona added  */}
                                <div class="card-header dark text-start">
                                    <span class="fw-bold">Gold</span>
                                    <div class="d-flex">  <h3 class="me-2">₹ 250</h3><span>/Month/User</span></div>
                                    <p class="plan-desc p-0">Comprehensive package for accelerated growth — top-tier value, priority support, and faster delivery.
                                    </p>
                                </div>
                                <div className="card-body-btn row mx-1 ">
                                    <button className="border plan-btn-shadow py-2 " onClick={() => setShowContactModal(true)}> <i className="bi bi-briefcase-fill me-2"></i>Talk To Us</button>
                                </div>
                                <div class="card-body">
                                    <ul className="space-y-2">
                                        <li className="flex items-center gap-2">
                                            <CheckCircleOutlineIcon sx={{ color: "#16a34a", fontSize: 18 }} />
                                            <span>Per month</span>
                                        </li>

                                        <li className="flex items-center gap-2">
                                            <CheckCircleOutlineIcon sx={{ color: "#16a34a", fontSize: 18 }} />
                                            <span>+18% GST</span>
                                        </li>

                                        <li className="flex items-center gap-2">
                                            <CheckCircleOutlineIcon sx={{ color: "#16a34a", fontSize: 18 }} />
                                            <span>Billed Monthly</span>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="left-info pt-2" data-animation="animated fadeInUpBig">
                        <ul class="action-btn-list">
                            <li>

                                <button onClick={() => setShowPricing(true)} className="btn-two">
                                    Compare All plans <span className="btn-icon"><ArrowForwardIcon fontSize="small" /></span>
                                </button>
                            </li>

                            <li>
                                <button onClick={() => setShowContactModal(true)} className="btn-two">
                                    Get started for Free <span className="btn-icon"><ArrowForwardIcon fontSize="small" /></span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            {/* start card of price when clik  */}
            {showPricing && (
                <section class="app-section col-12 container-fluid p-3  border faq-hover" id="pricingShowHide">
                    <div className="d-flex justify-content-center ">
                        <div className="billing-wrapper">
                            <div className="billing-toggle" role="tablist" aria-label="Billing cycle toggle">
                                <button
                                    type="button"
                                    aria-label="Monthly billing"
                                    aria-pressed={billingCycle === "monthly"}
                                    aria-controls="pricing-cards"
                                    onClick={() => setBillingCycle("monthly")}
                                    className={`toggle-btn ${billingCycle === "monthly" ? "active" : ""}`}
                                >
                                    Monthly
                                </button>
                                <button
                                    type="button"
                                    aria-label="Annual billing"
                                    aria-pressed={billingCycle === "annually"}
                                    aria-controls="pricing-cards"
                                    onClick={() => setBillingCycle("annually")}
                                    className={`toggle-btn ${billingCycle === "annually" ? "active" : ""}`}
                                >
                                    Annually
                                </button>
                            </div>
                            {/* {billingCycle === "annually" && (
                                <div className="save-badge" aria-hidden="false">SAVE&nbsp;25%</div>
                            )} */}
                        </div>
                    </div>


                    <div className="row g-4 mt-1 justify-content-center">
                        {plans.map((plan, index) => (
                            <div key={index} className="col-12 col-md-6 col-lg-3">
                                <div className={`pricing-card ${plan.popular ? "popular" : ""}`}>

                                    {plan.popular && <div className="popular-badge">Most Popular</div>}

                                    <span className={`plan-tag ${plan.color}`}>{plan.name}</span>
                                    {billingCycle === "annually" && plan.discount > 0 && (
                                        <div className="save-badge-pricingHrms mt-1">
                                            SAVE&nbsp;{plan.discount}%
                                        </div>
                                    )}
                                    <h3 className="price">
                                        {billingCycle === "monthly" ? plan.monthly : plan.Annually}
                                        <span style={{ fontSize: '13px', color: 'gray' }}> / User / Month</span>
                                    </h3>

                                    <span className="price-cycle">
                                        {billingCycle === "monthly" ? "Billed Monthly" : "Billed Annually"}
                                    </span>

                                    <ul className="feature-list">
                                        {featureRows
                                            .filter((row) => plan.features[row.key])
                                            .slice(
                                                0,
                                                expandedCards[index] ? featureRows.length : 7
                                            )
                                            .map((row) => {
                                                const value = plan.features[row.key];

                                                return (
                                                    <li key={row.key} className="flex items-center gap-2">
                                                        {(value === true || typeof value === "string") && (
                                                            <CheckCircleOutlineIcon
                                                                sx={{ color: "#16a34a", fontSize: 18 }}
                                                            />
                                                        )}

                                                        <span>
                                                            {row.label}
                                                            {typeof value === "string" && `: ${value}`}
                                                        </span>
                                                    </li>

                                                );
                                            })}

                                        {/* READ MORE TEXT */}
                                        {!expandedCards[index] &&
                                            featureRows.filter(row => plan.features[row.key]).length > 7 && (
                                                <li
                                                    className="read-more-text"
                                                    onClick={() => toggleFeatures(index)}
                                                >
                                                    show more…
                                                </li>
                                            )}

                                        {/* SHOW LESS TEXT */}
                                        {expandedCards[index] && (
                                            <li
                                                className="read-more-text"
                                                onClick={() => toggleFeatures(index)}
                                            >
                                                show less
                                            </li>
                                        )}
                                    </ul>
                                    <button onClick={() => setShowContactModal(true)} className="btn-two">
                                        Contact To Sales <span className="btn-icon"><ArrowForwardIcon fontSize="small" /></span>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                </section>
            )}

            {/* CONTACT MODAL */}
            <ContactSalesModal
                show={showContactModal}
                onClose={() => setShowContactModal(false)}
            />
        </>

    );
};

export default PricingHrms;